import { ClassicPreset as Classic } from 'rete';
import type { TaskNode } from './task-node';

export class Connection<
  A extends TaskNode,
  B extends TaskNode,
> extends Classic.Connection<A, B> {}
